// extracted by mini-css-extract-plugin
module.exports = {"insightsDetails":"insightsDetail_insightsDetails__NZCaM","socialButtons":"insightsDetail_socialButtons__JwfMX","topic":"insightsDetail_topic__XORZU"};